<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div>
        <div class="sticky-table-header">
            <vx-card style="overflow-x: auto;">
                <vs-row>
                    <vs-col class="search-bar" vs-type="flex" vs-justify="right" vs-align="center">
                        <vs-input ref="searchTxt" icon-no-border icon="icon-search" icon-pack="feather" class="w-full input-rounded-full" placeholder="Pencarian berdasarkan tanggal order/no lab/nama pasien" v-model="searchText"  v-on:keyup.enter="search"  v-on:keyup.tab="searchTabClick"/>
                        <vs-tooltip text="Cetak Barcode" v-if="btnBarcode===true">
                            <vs-button radius size="large" type="border" color="#828282" icon="calendar_view_day" class="ml-3" @click="startBarcode"></vs-button>
                        </vs-tooltip>
                        <vs-tooltip text="Mulai Pemeriksaan" v-if="btnStart===true">
                            <vs-button radius size="large" type="border" color="#2a8619" icon="label" class="ml-3" @click="start"></vs-button>
                        </vs-tooltip>
                        <vs-tooltip text="Entri Data" v-if="btnEntry===true">
                            <vs-button radius size="large" type="border" color="#2dadb9" icon="library_books" class="ml-3" @click="entry"></vs-button>
                        </vs-tooltip>
                        <vs-tooltip text="Verifikasi" v-if="btnVerify===true">
                            <vs-button radius size="large" type="border" color="#2196f3" icon="thumb_up" class="ml-3" @click="verify"></vs-button>
                        </vs-tooltip>
                        <vs-tooltip text="Validasi" v-if="btnVerifyFin===true">
                            <vs-button radius size="large" type="border" color="#640065" icon="thumb_up" class="ml-3" @click="valid"></vs-button>
                        </vs-tooltip>
                        <vs-tooltip text="Detail Test" v-if="btnDetail===true">
                            <vs-button radius size="large" type="border" color="#a92299" icon="content_paste" class="ml-3" @click="activePromptWorklist=true;action='Detail';buttonHidden=true;getDetail(idselected)"></vs-button>
                        </vs-tooltip>
                        <vs-tooltip text="Cetak PDF" v-if="btnPdf===true">
                            <vs-button radius size="large" type="border" color="#5d9fc6" icon="print" class="ml-3" @click="printPDF"></vs-button>
                        </vs-tooltip>
                        <vs-tooltip text="Edit" v-if="btnEdit===true">
                            <vs-button radius size="large" type="border" color="warning" icon="edit" class="ml-3" @click="edit"></vs-button>
                        </vs-tooltip>
                        <vs-tooltip text="Hapus" v-if="btnDel===true">
                            <vs-button radius size="large" type="border" color="danger" icon="delete" class="ml-3" @click="hapus"></vs-button>
                        </vs-tooltip>
                        <vs-tooltip text="Log Instrument" v-if="btnLog===true">
                            <vs-button radius size="large" type="border" color="#634f9f" icon="warning" class="ml-3"></vs-button>
                        </vs-tooltip>
                        <vs-tooltip text="Admin Edit" v-if="btnAdminEdit===true">
                            <vs-button radius size="large" type="border" color="warning" icon="edit" class="ml-3" @click="adminEdit"></vs-button>
                        </vs-tooltip>
                    </vs-col>
                </vs-row>
            </vx-card>
        </div>

      <vx-card title="Worklist" class="sticky-table-content1 mt-sticky">
        <vs-table
            max-items="20"
            :data="listWorklist"
            :class="showFixedHeader?'sticky-header':''"
            @selected="handleSelected">

            <template slot="thead">
                <vs-th class="vs-lg-1">No Lab</vs-th>
                <vs-th class="vs-lg-2">Status</vs-th>
                <vs-th class="vs-lg-3">Pasien</vs-th>
                <vs-th class="vs-lg-2">Data Lab</vs-th>
                <vs-th class="vs-lg-3">Pemeriksaan</vs-th>
                <vs-th class="vs-lg-1">Operator</vs-th>
            </template>

            <template slot-scope="{data}">
              <tbody :key="indextr" v-for="(tr, indextr) in data">
                <vs-tr :data="tr" :style="tr.id==idSelected?'background: rgba(var(--vs-primary),.1)!important;':(indextr%2==0?'background: transparent!important;':'')">
                    <vs-td class="vs-lg-1 text-center" style="padding-left: 7px !important; padding-right: 7px !important">
                        <b>{{data[indextr].visitNumber}}</b><br/>
                        {{data[indextr].visitDate | formatDate}}<br/>{{data[indextr].externalNumber}}
                    </vs-td>
                    <vs-td class="vs-lg-2 text-center">
                        <span class="flex items-center px-2 py-1 rounded" v-if="data[indextr].testStatusName=='PENDING'">
                          <div class="h-3 w-3 rounded-full mr-2" :class="'bg-warning'"></div>{{data[indextr].testStatusName}}
                        </span>
                        <span class="flex items-center px-2 py-1 rounded" v-if="data[indextr].testStatusName=='STARTED'" >
                          <div class="h-3 w-3 rounded-full mr-2" style="background-color: #2a8619 !important;"></div>{{data[indextr].testStatusName}}
                        </span>
                        <span class="flex items-center px-2 py-1 rounded" v-if="data[indextr].testStatusName=='COMPLETED'" >
                          <div class="h-3 w-3 rounded-full mr-2" style="background-color: #2dadb9 !important;"></div>{{data[indextr].testStatusName}}
                        </span>
                        <span class="flex items-center px-2 py-1 rounded" v-if="data[indextr].testStatusName=='VERIFIED'" >
                          <div class="h-3 w-3 rounded-full mr-2" style="background-color: #2196f3 !important;"></div>{{data[indextr].testStatusName}}
                        </span>
                        <span class="flex items-center px-2 py-1 rounded" v-if="data[indextr].testStatusName=='VERIFIED FINAL'" >
                          <div class="h-3 w-3 rounded-full mr-2" style="background-color: #640065 !important;"></div>{{'VALIDATED'}}
                        </span>
                        <span class="flex items-center px-2 py-1 rounded" v-if="data[indextr].testStatusName=='DELETED'" >
                          <div class="h-3 w-3 rounded-full mr-2" :class="'bg-danger'"></div>{{data[indextr].testStatusName}}
                        </span>
                        <vs-progress :percent="data[indextr].percentage" color="success"></vs-progress>
                    </vs-td>
                    <vs-td class="vs-lg-3">
                        <b>{{data[indextr].patient?data[indextr].patient.name:''}} {{' ('+(data[indextr].patient?data[indextr].patient.patientNumber:'')+')'}}</b><br/>
                        <label style="font-size: 12px">{{data[indextr].patient.dob | calcAge1}} {{(data[indextr].patient?' / '+data[indextr].patient.gender.name:'')}}</label>
                    </vs-td>
                    <vs-td class="vs-lg-2 text-center">
                      <b>{{data[indextr].patientTypeName}} | {{data[indextr].priorityName}}</b><br/>
                      <label style="font-size: 12px">{{data[indextr].wardName}}</label>
                    </vs-td>
                    <vs-td class="vs-lg-3 text-center">
                        <span v-if='tr.testNameV2!=null'>
                          <vs-chip :key="'test_name_' + j" v-for="(testName,j) in tr.testNameV2" v-if="j < 4" :color="testName.colorValue">{{testName.name}}</vs-chip>
                      </span>
                    </vs-td>
                    <vs-td class="vs-lg-1 text-center">
                      <ul class="users-liked user-list">
                        <li v-if="tr.testedBy!=null">
                          <vx-tooltip :text="'Inputer: '+tr.testedBy.name" position="bottom">
                              <vs-avatar :src="tr.testedBy.image" size="30px" class="border-2 border-white border-solid -m-1"></vs-avatar>
                          </vx-tooltip>
                        </li>
                        <li v-if="tr.verifiedBy!=null">
                          <vx-tooltip :text="'Verifier: '+tr.verifiedBy.name" position="bottom">
                              <vs-avatar :src="tr.verifiedBy.image" size="30px" class="border-2 border-white border-solid -m-1"></vs-avatar>
                          </vx-tooltip>
                        </li>
                        <li v-if="tr.verified2By!=null">
                          <vx-tooltip :text="'Validator: '+tr.verified2By.name" position="bottom">
                              <vs-avatar :src="tr.verified2By.image" size="30px" class="border-2 border-white border-solid -m-1"></vs-avatar>
                          </vx-tooltip>
                        </li>
                      </ul>
                    </vs-td>
                </vs-tr>
              </tbody>
            </template>
        </vs-table>
        <vs-pagination class="pagination pagination-warning" :total="totalItem" v-model="page" @input="find"></vs-pagination>
      </vx-card>

       <vs-prompt class="w80"
         style="overflow: auto:"
         :title="(action=='Start'?'Konfirmasi Mulai Pemeriksaan Worklist':
            (action=='Detail'?'Detail Worklist':'Edit Form Worklist'))"
         @accept="start"
         :accept-text="(action=='Start'?'Mulai Pemeriksaan':(action=='Detail'?'Tutup':'Simpan'))"
         cancel-text="Batal"
         color="#6488e4"
         :buttons-hidden="buttonHidden"
         :active.sync="activePromptWorklist">
          <patient :dataPatient="dataPatient" :subm="subm" :action="action" from="WorklistClinic"/>
        </vs-prompt>

       <vs-prompt class="w50"
         style="overflow: auto:"
         title="Cetak Barcode"
         @accept="barcode"
         accept-text="Cetak"
         cancel-text="Batal"
         color="#6488e4"
         :buttons-hidden="buttonHidden"
         :active.sync="activePromptBarcode">

          <div class="vx-row" flex>
            <div class="vx-col w-full mb-2">
              <vs-select
                autocomplete
                class="w-full"
                name="printer"
                label="Nama Printer"
                v-model="printer"
              >
                <vs-select-item
                  :key="index"
                  :value="item.id"
                  :text="item.name"
                  v-for="(item,index) in listPrinter"
                />
              </vs-select>
            </div>
          </div>
        </vs-prompt>        
    </div>
</template>

<script>
import visit from "@/api/visit";
import master from "@/api/master";
import Patient from '../Patient';

export default {
  components: {
    Patient
  },
  data() {
    return {
      idSelected: null,
      activePromptWorklist:false,
      dataPatient: {},
      listWorklist: [],
      listTest: [],
      obj: {},
      printer:'',
      btnEdit: false,
      btnDel: false,
      btnBarcode: false,
      btnStart: false,
      btnEntry: false,
      btnVerify: false,
      btnVerifyFin: false,
      btnDetail: false,
      btnPdf: false,
      btnLog: false,
      btnAdminEdit: false,
      listPrinter: [],
			model: {},
			modelt: {},
      buttonHidden: false,
			schema: {
				fields: []
			},
			formOptions: {
				validateAfterLoad: true,
				validateAfterChanged: true,
				validateAsync: true
			},
      subm: false,
      action: '',
      page: 1,
      totalItem: 0,
      searchText: '',
      isUserScrolling: false,
      showFixedHeader: false,
      isMobile: false,
      activePromptBarcode: false,
    };
  },
  methods: {
    openConfirm(id) {
        this.idSelected = id
        this.$vs.dialog({
            type: 'confirm',
            color: 'danger',
            title: `Confirm`,
            text: 'Anda yakin menghapus data ini ?',
            acceptText: 'Ya',
            cancelText: 'Tidak',
            accept: this.acceptAlert
        })
    },
    acceptAlert() {
    },
		async find(pg) {
      this.disabledBtn();
      this.page = pg;
			this.model["perPage"] = this.perPage;
      this.model["page"] = pg;
      this.model["lab_section_id"] = 1;

      this.$vs.loading({
        type:'sound',
      });

			const frm = await visit.listWorklistClinic(this.model);
			if (frm.data.status) {
				this.listWorklist = frm.data.data;
				this.totalItem = frm.data.maxPage;
			} else {
			   this.listWorklist = [];
      }

      this.$vs.loading.close();
		},
		async search() {
      this.page = 1;
			this.model["perPage"] = this.perPage;
      this.model["page"] = 1;
      this.model["lab_section_id"] = 1;
      this.model["keyword"] = this.searchText

      this.$vs.loading({
        type:'sound',
      });

			const frm =
      await visit.listWorklistClinic(this.model)
      .then(frm => {
  			if (frm.data.status) {
  				this.listWorklist = frm.data.data;
  				this.totalItem = frm.data.maxPage;
  			} else {
  			   this.listWorklist = [];
        }

        this.$vs.loading.close();
      })
      .catch(err => {
  			if (error.response) {
  				this.$vs.notify({
  				  title: 'Information',
  				  time: 3000,
  				  text: error.response.data.message,
  				  iconPack: 'feather',
  				  icon: 'icon-alert-circle',
  				  color: 'danger',
  				  position: 'top-right'
  				});
  			}

        this.$vs.loading.close();
  		});
		},
    disabledBtn() {
      this.btnEdit =false;
      this.btnBarcode=false;
      this.btnStart=false;
      this.btnEntry=false;
      this.btnVerify=false;
      this.btnVerifyFin=false;
      this.btnDetail=false;
      this.btnPdf=false;
      this.btnLog=false;
      this.btnAdminEdit=false;
      this.btnDel=false;
    },
    handleSelected(tr) {
      this.disabledBtn();
      this.idSelected = tr.id;
      this.listWorklist.forEach(element => {
        if (element.id == this.idSelected) {
          this.btnEdit = true;
          this.btnDel = false;
          this.btnBarcode = true;
          this.btnDetail = false;
          this.btnAdminEdit=false;
          if (element.testStatusName == 'PENDING') {
            this.btnStart = true;
            this.btnDel = true;
          } else if (element.testStatusName == 'VERIFIED FINAL') {
            this.btnPdf = true;
            this.btnEdit = false;
            if (JSON.parse(localStorage.getItem("userInfo")).userRole==='admin') {
              this.btnAdminEdit = true;
            }
          } else if (element.testStatusName == 'VERIFIED') {
            this.btnEdit = true;
            this.btnVerifyFin = true;
          } else if (element.testStatusName == 'COMPLETED') {
            this.btnEdit = true;
            this.btnVerify = true;
            this.btnVerifyFin = true;
          } else if (element.testStatusName == 'STARTED') {
            this.btnEntry=true;
            this.btnVerify=true;
            this.btnVerifyFin = true;
            this.btnPdf=true;
            this.btnDel = true;
          }
        }
      });
    },
		async getDetail(id) {
			const frm = await visit.getDetailV2(id);
			if (frm.data.status) {
				this.dataPatient= frm.data.data[0];
        console.log('list test patient 123 :'+JSON.stringify(this.dataPatient));
			}
		},
    async printPDF() {
      this.$vs.loading({
        type:'sound',
      });

      const frm = await visit.getVerifyFinal2(this.idSelected);
      if (frm.data.status) {
        this.$vs.loading.close();
        this.$router.push({name: 'clinic-pdf', params: frm.data.data[0]});
      }
    },
    start() {
      if (this.idSelected) {
        this.$router.push({name: 'worklist-start', params: {id: this.idSelected, from: 'clinic', action: 'Start'}});
      }
    },
    async barcode() {
      console.log(this.printer);
      if (this.idSelected) {
        this.loading = true;
        let config = {
          headers: {
            "content-type": "application/json"
          }
        };
        let model = { id: this.idSelected, printerId: this.printer};
        const frm = await visit.barcode(model);
        this.$vs.loading.close();
      }
    },   
    startBarcode() {
      this.activePromptBarcode = true;
    },
    edit() {
      if (this.idSelected) {
        this.$router.push({name: 'worklist-start', params: {id: this.idSelected, from: 'clinic', action: 'Update'}});
      }
    },
    adminEdit() {
      if (this.idSelected) {
        this.$router.push({name: 'worklist-valid', params: {id: this.idSelected, from: 'clinic', action: 'AdminEdit'}});
      }
    },
    hapus() {
      if (this.idSelected) {
        this.$router.push({name: 'worklist-start', params: {id: this.idSelected, from: 'clinic', action: 'Delete'}});
      }
    },
    entry() {
      if (this.idSelected) {
        this.$router.push({name: 'worklist-entry', params: {id: this.idSelected, from: 'clinic'}});
      }
    },
    verify() {
      if (this.idSelected) {
        this.$router.push({name: 'worklist-verify', params: {id: this.idSelected, from: 'clinic'}});
      }
    },
    valid() {
      if (this.idSelected) {
        this.$router.push({name: 'worklist-valid', params: {id: this.idSelected, from: 'clinic'}});
      }
    },
    async firstLoad() {
        const m = {type: 'PRINTERBARCODE'}
        const frm = await master.listInstrument(m);
        if (frm.data.status) {
          this.listPrinter = frm.data.data;
        }
    },
    handleScroll(ev) {
      if(!this.isMobile) {
          this.isUserScrolling = (window.scrollY > 0);
          if (this.isUserScrolling) {
              if (window.pageYOffset > 45) {
                  this.showFixedHeader = true;
              } else {
                  this.showFixedHeader = false;
              }
          } else {
              this.showFixedHeader = false;
          }
      }
    },
    setFocusOnInput(inputName) {
       /**
        * @see https://vuejs.org/v2/api/#vm-el
        * @see https://vuejs.org/v2/api/#vm-refs
        */
        // you could just call this.$refs[inputName].focusInput() but i'm not shure if it belongs to the public API
        let inputEl = this.$refs[inputName].$el.querySelector('input');
        console.log(inputEl.focus);
        inputEl.focus();
    },
    isMobileDevice() {
        const toMatch = [
            /Android/i,
            /webOS/i,
            /iPhone/i,
            /iPad/i,
            /iPod/i,
            /BlackBerry/i,
            /Windows Phone/i
        ];

        console.log(navigator.userAgent);

        return toMatch.some((toMatchItem) => {
            return navigator.userAgent.match(toMatchItem);
        });
    }
  },
  computed: {
  },
  mounted() {
      this.isMobile = this.isMobileDevice();
  },
  created() {
      this.firstLoad();
      document.addEventListener('scroll', this.handleScroll);
      this.$nextTick(() => this.setFocusOnInput('searchTxt'))
  },
  destroyed() {
      document.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="scss">
.w50 .vs-dialog {
    max-width:50%;
}

.w80 .vs-dialog {
    max-width:80%;
}
</style>
